/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Status_OfferedInputs */

const id_tld_pricing_status_offered = /** @type {(inputs: Tld_Pricing_Status_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

const en_tld_pricing_status_offered = /** @type {(inputs: Tld_Pricing_Status_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offered`)
};

/**
* | output |
* | --- |
* | "Offered" |
*
* @param {Tld_Pricing_Status_OfferedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_status_offered = /** @type {((inputs?: Tld_Pricing_Status_OfferedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Status_OfferedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_status_offered(inputs)
	return id_tld_pricing_status_offered(inputs)
});